import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5536000c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "driver-alert-container"
}
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-triangle-exclamation no-truck-data-icon" }, null, -1))
const _hoisted_4 = { class: "no-truck-data-heading" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-truck-data-text" }, "Please contact your DM/DL to resolve this issue.", -1))
const _hoisted_6 = { class: "return-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (!_ctx.isLoading && (_ctx.isMissingTruckOrDriver || _ctx.isMissingTruckLocation))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ReturnOptions)
        ])
      ]))
    : _createCommentVNode("", true)
}